import { useMemo } from 'react';
import { Table, IconLoader } from '@ui/src';
import formatHistoryRateList from './helpers/format-history-rate';
import { HistoryRateListTypes, RateItem } from './types';
import {
  rateHistoryColumns,
  expandableRateHistoryColumns,
} from './variables/history-list';

import cn from './styles.module.css';

const HistoryRateList = ({
  history,
  isLoading,
  isFetching,
  pagination,
  setPage,
  rateError,
  getRateHistoryDetails,
  rateHistoryDetailsIsLoading,
  isSuccessExpandableRow,
}: HistoryRateListTypes): React.JSX.Element => {
  const formattedData = useMemo(() => {
    const data = formatHistoryRateList(history as RateItem[]);

    return data;
  }, [history]);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.historyLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <div className={cn.rateHistoryTableWrapper}>
        <Table
          filters={{}}
          onFilterChange={() => {}}
          columns={rateHistoryColumns}
          data={formattedData || []}
          error={rateError}
          isLoading={isFetching}
          tableBodyClassName={!history?.length ? cn.logsEmptyTable : ''}
          onExpand={getRateHistoryDetails}
          isLoadingExpandableRow={rateHistoryDetailsIsLoading}
          isSuccessExpandableRow={isSuccessExpandableRow}
          onSort={() => {}}
          sort={{}}
          columnsLabels={{}}
          expandableColumns={expandableRateHistoryColumns}
          pagination={pagination}
          expandableColspanValue={3}

          setPage={setPage}
          transactionTable
          take="10"
          expandable
        />
      </div>
    );
  }

  return content;
};

export default HistoryRateList;
